export default __webpack_public_path__ + "static/media/applications-image-21.db103341.jpg";